import AuditReportList from "../../components/Auditreport/AuditreportList";

export default function Auditreport(){
    return(
        <div>
            <AuditReportList/>
        </div>
    )
}